import { useNavbarItems } from '@/hooks/useNavbarItems';
import { ScrollArea, Stack } from '@mantine/core';
import { NavbarItem } from './NavbarItem';
export const NavbarMenu = () => {
  const {
    values: mainItems,
    handleItemClick: handleMainItemClick
  } = useNavbarItems();
  return <ScrollArea h={{
    base: '100%',
    lg: 550
  }} scrollbars="y" type="never">
      <Stack px={{
      lg: 8
    }} gap={10} mx={-10}>
        {mainItems.map((item, index) => <NavbarItem index={index} key={item.label} {...item} handleItemClick={handleMainItemClick} iconSize={20} />)}
      </Stack>
    </ScrollArea>;
};